import { Component, Input, Output, EventEmitter } from '@angular/core';

interface PartnerBrokerInfo {
	id: string;
	name: string;
}

interface ProductInfo {
	products: {
		id: string;
		name: string;
	};
}

@Component({
	selector: 'app-organization-info',
	styleUrls: ['./organization-info.component.scss'],
	templateUrl: './organization-info.component.html',
})
export class OrganizationInfoComponent {
	@Input() cnpj: string = '';
	@Output() editGroup: EventEmitter<string> = new EventEmitter();
	@Input() id: string = '';
	@Input() isFavorite: boolean = false;
	@Input() isMatriz: boolean = false;
	@Input() name: string = '';
	@Input() partnerBroker: PartnerBrokerInfo | null = null;
	@Input() products: ProductInfo[] = [];
	@Input() state: string = '';
	@Output() toggleFavoriteClicked: EventEmitter<boolean> = new EventEmitter();
	@Input() totalBeneficiaries: number = 0;
	@Input() totalUsers: number = 0;

	private readonly productColorMap: { [key: string]: string } = {
		'gestao de saude': 'blue',
		'gestao operacional': 'green',
		'gestão de saúde': 'blue',
		'gestão operacional': 'green',
		seguro: 'orange',
		'seguro de vida': 'orange',
		vida: 'orange',
	};

	private readonly productTagVariants: string[] = ['blue', 'green', 'orange'];

	getBrokerStatusClass(): string {
		return this.partnerBroker ? 'with-broker' : 'without-broker';
	}

	getBrokerStatusText(): string {
		return this.partnerBroker ? this.partnerBroker.name : 'Sem Corretora';
	}

	getProductTagClass(productName: string): string {
		const normalizedName = productName.toLowerCase().trim();

		// Primeiro, verifica o mapeamento fixo
		for (const [key, color] of Object.entries(this.productColorMap)) {
			if (normalizedName.includes(key)) {
				return `chip-${color}`;
			}
		}

		// Fallback para o algoritmo hash se o produto não estiver mapeado
		let hash = 0;

		for (let i = 0; i < normalizedName.length; i++) {
			const char = normalizedName.charCodeAt(i);
			hash = (hash << 5) - hash + char;
			hash |= 0;
		}

		const variantIndex = Math.abs(hash) % this.productTagVariants.length;

		return `chip-${this.productTagVariants[variantIndex]}`;
	}

	onEditGroup(name: string): void {
		this.editGroup.emit(name);
	}

	onToggleFavorite(isFavorite: boolean): void {
		this.toggleFavoriteClicked.emit(isFavorite);
	}

	onToggleFavoriteWrapper(): void {
		this.onToggleFavorite(this.isFavorite);
	}
}
